import * as React from 'react';
import { DeviceOs, DeviceType } from '../../logic/main/types';

export const DeviceContext = React.createContext<{
  deviceType: DeviceType;
  deviceOs: DeviceOs;
  deviceNative: boolean;
}>({ deviceType: 'mobile', deviceOs: null, deviceNative: false });

interface DeviceProviderPropTypes {
  children?: React.ReactNode;
  deviceType: DeviceType;
  deviceOs: DeviceOs;
  deviceNative: boolean;
  visible?: boolean;
}

const DeviceProvider: React.FC<DeviceProviderPropTypes> = ({
  children,
  visible = true,
  deviceType,
  deviceOs,
  deviceNative,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <DeviceContext.Provider value={{ deviceType, deviceOs, deviceNative }}>
      {children}
    </DeviceContext.Provider>
  );
};

export default DeviceProvider;
